<template>
  <div class="neibu_pup" v-loading = "loading">
    <div class="neibu_form" style="position: relative" >
      <div
        v-preventReClick
        style="
          position: absolute;
          right: 30px;
          top: 30px;
          font-size: 30px;
          color: #606266;
          cursor: pointer;
        "
        @click="back"
      >
        <i class="el-icon-circle-close" />
      </div>
      <div class="neibu_content">
        <img
          src="@/assets/img/nbsyth.png"
          style="height: 25px; margin-bottom: 37px"
        >
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="125px"
          label-position="right"
        >
          <el-form-item label="使用出库单号:" prop="syckdh">
            <el-select
              filterable
              clearable
              v-model="form.syckdh"
              style="width: 100%"
              placeholder="请选择"
              :disabled="nbsy || bgdisable"
              @change="ckdhChange"
            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="化学品:" prop="hxpmc">
            <el-input
              v-model="form.hxpmc"
              disabled
              placeholder="请输入化学品"
            />
          </el-form-item>
          <el-form-item label="领用人:" prop="syjbrmc">
            <el-input
              v-model="form.syjbrmc"
              disabled
              placeholder="请填写领用人"
            />
          </el-form-item>
          <el-form-item label="使用出库量:" prop="syckl">
            <el-input
              v-model="form.syckl"
              style="width: 65%"
              disabled
              placeholder="请填写使用出库量"
            />
            <el-select
              v-model="form.syckldw"
              style="width: calc(35% - 10px); margin-left: 10px"
              placeholder="单位"
              disabled
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="出库日期:" prop="ckrq">
            <el-date-picker
              v-model="form.ckrq"
              type="date"
              style="width: 100%"
              disabled
              placeholder="请选择日期"
            />
          </el-form-item>
          <el-form-item label="仓库名称:" prop="thckmc">
            <el-input
              v-model="form.thckmc"
              disabled
              placeholder="请填写仓库名称"
            />
          </el-form-item>
          <el-form-item label="退回量:" prop="thsl">
            <el-input
              v-model="form.thsl"
              style="width: 65%"
              :disabled="nbsy"
              placeholder="请输入"
            />
            <el-select
              v-model="form.thsldw"
              style="width: calc(35% - 10px); margin-left: 10px"
              placeholder="单位"
              :disabled="nbsy"
            >
              <el-option
                v-for="item in dwlxList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="退回经办人:" prop="jbr">
            <el-input
              v-if = "nbsy || bgdisable"
              v-model="form.jbrxm"
              disabled
            />
            <el-select
              v-else
              v-model="form.jbr"
              filterable
              style="width: 100%"
              placeholder=""
              @change="jbrChange"
            >
              <el-option
                v-for="item in lyrList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="退回日期:" prop="thrq">
            <el-date-picker
              v-model="form.thrq"
              type="date"
              :picker-options="pickerOptions"
              style="width: 100%"
              :disabled="nbsy"
              placeholder="请选择日期"
            />
          </el-form-item>
          <el-form-item v-if="djsjdisable" label="登记时间:" prop="djsj">
            <el-input
              v-model="form.djsj"
              disabled
              placeholder="请填写登记时间"
            />
          </el-form-item>
          <el-form-item v-else label="登记时间:">
            <el-date-picker
              :value="new Date()"
              type="date"
              style="width: 100%;"
              placeholder="选择日期"
              disabled
              format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item
            v-if="leixing == 'add' || leixing == 'copy'"
            label="登记人:"
            prop="djr"
          >
            <el-input
              v-model="djr"
              disabled
              placeholder="请填写登记人"
            />
          </el-form-item>
          <el-form-item v-else label="登记人:" prop="djr">
            <el-input
              v-model="form.djrxm"
              disabled
              placeholder="请填写登记人"
            />
          </el-form-item>
          <el-form-item style="width: 100%" label="备注:" prop="bz">
            <el-input
              v-model="form.bz"
              style="width: 100%"
              type="textarea"
              :disabled="nbsy || bgdisable"
              :rows="2"
              resize="none"
              placeholder="请输入内容"
            />
          </el-form-item>
          <el-form-item
            v-if="bgdisable"
            label="变更理由:"
            prop="bgly"
            style="width: 100%"
          >
            <el-input
              v-model="form.bgly"
              type="textarea"
              :rows="3"
              resize="none"
              style="width: 100%"
              placeholder="请输入"
            />
          </el-form-item>
        </el-form>
        <!--新增 -->
        <div
          v-if="
            curRowObjnbsy.bgcs == 0 || !curRowObjnbsy.bgcs || leixing == 'add'
          "
        >
          <div v-if="!nbsy && !djsjdisable && !bgdisable" class="buttonList">
            <el-button
              v-preventReClick
              type="primary"
              @click="submitFormTemp('form')"
            >暂时保存</el-button>
            <el-button
              v-preventReClick
              style=""
              type="primary"
              @click="submitForm('form', 'tj')"
            >入库</el-button>
          </div>

          <!-- 查看 -->
          <div v-if="nbsy && djsjdisable && !bgdisable" class="XINbuttonList">
            <el-button
              v-preventReClick
              class="tjsq"
              @click="submitForm('form', 'ck')"
            >确定</el-button>
          </div>

          <!-- 变更 -->
          <div v-if="!nbsy && djsjdisable && bgdisable" class="XINbuttonList">
            <el-button
              v-preventReClick
              class="tjsq"
              @click="submitForm('form', 'bg')"
            >提交变更</el-button>
          </div>

          <!-- 编辑  -->
          <div v-if="!nbsy && djsjdisable && !bgdisable" class="buttonList">
            <el-button
              v-preventReClick
              type="primary"
              @click="submitFormTemp"
            >暂时保存</el-button>
            <el-button
              v-preventReClick
              style=""
              type="primary"
              @click="submitForm('form', 'tj')"
            >入库</el-button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="curRowObjnbsy.bgcs > 0 && (leixing == 'ck' || leixing == 'bg')"
      class="neibu_content_list"
    >
      <div class="neibu_content">
        <img
          src="@/assets/img/nbsyth.png"
          style="height: 25px; margin-bottom: 37px"
        >
        <bgcsOfDetail
          :cur-row-obj="curRowObjnbsy"
          :cur-type="'21'"
          :bgcs-t-k-name="'disShow'"
          @bacsCkXqShow="bacsCkXqShow"
        />
        <div>
          <!-- 查看 -->
          <div v-if="nbsy && djsjdisable && !bgdisable" class="XINbuttonList">
            <el-button
              v-preventReClick
              class="tjsq"
              @click="submitForm('form', 'ck')"
            >确定</el-button>
          </div>

          <!-- 变更 -->
          <div v-if="!nbsy && djsjdisable && bgdisable" class="XINbuttonList">
            <el-button
              v-preventReClick
              class="tjsq"
              @click="submitForm('form', 'bg')"
            >提交变更</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="dialogFormVisible" class="purchase_pupop">
      <!-- 详情弹框 -->
      <el-dialog :visible.sync="dialogFormVisible" width="1200px" center>
        <bgxqCom
          v-if="dialogFormVisible"
          :bgcs-t-k-name="'内部使用退回'"
          :dgcs-xq-id="dgcsXqId"
        />
        <div slot="footer" class="dialog-footer">
          <el-button
            v-preventReClick
            type="primary"
            style="background-color: #4170ff; border: none"
            @click="dialogFormVisible = false"
          >确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  addNbstMes,
  editNbstMes,
  getkv,
  getnbsyckMes,
  getnbsyDetailMes,
  getnbsyckdhMes,
  lyrOptions,
  userInfofLogin,
  nbsybgqjc,
  nbsybg, addNbstMesTemp, editNbstMesTemp
} from '@/assets/js/common.js'
import { getdwforhxpBm } from '@/assets/js/yssq'
import { lengthValidate } from '@/assets/js/validate.js'
import bgcsOfDetail from '../bgxq/bgInDetail.vue'
import bgxqCom from '../bgxq/bgxqCom.vue'
import {dealDataGy} from "@/utils/ppp";
export default {
  components: { bgcsOfDetail, bgxqCom },
  props: {
    curRowObjnbsy: {
      type: Object
    },
    nbsy: {
      type: Boolean
    },
    djsjdisable: {
      type: Boolean
    },
    bgdisable: {
      type: Boolean
    },
    leixing: {
      type: String
    },
    rowId: {
      type: String
    }
  },
  data() {
    const sljiaoyan = (rule, value, callback) => {
      if (!(this.form.thsl + '')) {
        return callback(new Error('请填写退回数量值'))
      }
      // if (this.form.thsl < 0) {
      //   return callback(new Error("请填写不小于0的退回数量值"));
      // }
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/;
      if (!this.bgdisable && !reg.test(this.form.thsl)) {
        callback(new Error("请输入大于或等于0的数量值"));
      }
      if (/^-?[1-9]\d{0,8}(\.\d{1,3})?$|^-?0(\.\d{1,3})?$/.test(this.form.thsl) == false) {
        callback(new Error('整数位最大长度9位,保留3位小数'))
      }
      if (!this.form.thsldw) {
        return callback(new Error('请选择退回数量单位'))
      }
      callback()
    }
    return {
      loading: false,
      dgcsXqId: null,
      dialogFormVisible: false,
      curType: '',
      curRowObj: {}, // 当前行的对象
      bgcsTKName: '购买入库',
      bgwindow: false,
      // 日期限制
      pickerOptions: {
        disabledDate: (time) => {
          return time > Date.now()
        }
      },
      form: {
        id: '',
        syckdh: '', // 出库单号
        hxpbm: '',
        hxpmc: '', // 化学品
        syjbrmc: '', // 经办人名称
        syckl: '', // 使用出库量
        syckldw: '', // 使用出库量单位
        ckrq: '', // 出库日期
        thckbh: '', // 退回仓库编码
        thckmc: '', // 仓库名称
        // 以上带出
        thsl: '', // 退回量
        thsldw: '', // 退回量单位
        jbr: '',
        jbrxm: '',
        thrq: '', // 退回日期
        zt: '',
        bz: '', // 备注
        // 详情
        rkbh: '',
        djr: '',
        djrxm: '',
        djsj: '',
        bgly: ''
      },
      rules: {
        syckdh: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ],
        hxpmc: [
          {
            required: true,
            message: '请选择化学品',
            trigger: ['blur', 'change']
          }
        ],
        syjbrmc: [
          {
            required: true,
            message: '请输入',
            trigger: ['blur', 'change']
          }
        ],
        syckl: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ],
        syckldw: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ],
        ckrq: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ], // 出库日期
        thckmc: [
          {
            required: true,
            message: '请输入',
            trigger: ['blur', 'change']
          }
        ], // 出库仓库名称
        thsl: [
          {
            required: true,
            validator: sljiaoyan,
            trigger: ['blur', 'change']
          }
        ], // 退回量
        thsldw: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ], // 退回量单位
        jbr: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ], // 使用退回经办人
        thrq: [
          {
            required: true,
            message: '请选择',
            trigger: ['blur', 'change']
          }
        ], // 退回日期
        bz: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        bgly: [
          {
            required: true,
            message: '请填写变更理由',
            alidator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      options: [], // 化学品数量单位
      dwlxList: [], // 化学品带出单位
      options1: [], // 仓库
      options2: [], // 出库单号
      lyrList: [], // 领用人
      djr: ''
    }
  },
  computed: {},
  watch: {
    form: {
      deep: true,
      handler(val) {
        if (val.hxpbm) {
          getdwforhxpBm(this.form.hxpbm).then((e) => {
            this.dwlxList = e.data.data
          })
        }
      }
    }
  },
  created() {
    // 化学品数量单位
    getkv('yzd_nsjsl_dw').then((e) => {
      this.options = e.data.data
    })
    if(this.leixing == 'add'){
      this.getJbrxx()
    }
    getnbsyckMes().then((e) => {
      this.options1 = e.data.data
    })
    getnbsyckdhMes().then((e) => {
      this.options2 = e.data.data
    })
    userInfofLogin().then((res) => {
      if (res.status == 200) {
        this.djr = res.data.data.name
      }
    })
  },
  beforeDestroy() {
    this.$bus.$off('fatherToChil')
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.on('fatherToChil', this.initCon)
    })
    this.getInformationByType()
  },
  methods: {
    jbrChange(val) {
      this.lyrList.forEach((item) => {
        if (item.value == val) {
          this.form.jbrxm = item.label
        }
      })
    },
    lengthValidate,
    bacsCkXqShow(id) {
      this.dgcsXqId = id
      this.dialogFormVisible = !this.dialogFormVisible
    },
    initCon(curRow, curType) {
      this.curRowObj = curRow
      this.curType = curType
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    getInformationByType() {
      if (this.leixing == 'add') {
      } else this.getformMes()
    },
    getformMes() {
      getnbsyDetailMes(this.rowId).then((e) => {
        let mesxx = {...e.data.data}
        if(!this.bgdisable && this.leixing != 'ck'){
          mesxx.jbr = this.form.jbr
          mesxx.jbrxm = this.form.jbrxm
        }
        this.form = mesxx
        this.form.id = this.leixing == 'copy' ? '' : e.data.data.id // 根据id来知道编辑的数据
        this.form.syckdh = this.leixing == 'copy' ? '' : e.data.data.syckdh
        if(!this.bgdisable && this.leixing != 'ck'){
          this.getJbrxx(e.data.data)
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate() //清楚页面所有校验结果
        })
      })
    },
    //加载经办人信息
    getJbrxx(dataMes){
      lyrOptions().then((res) => {
        if (res.status == 200) {
          this.lyrList = res.data.data
          if(dataMes && dataMes.jbr){
            this.lyrList.findIndex((item) => {
              if(item.value == dataMes.jbr){
                this.form.jbr = dataMes.jbr
                this.form.jbrxm = dataMes.jbrxm
                return
              }
            })
          }

        }
      })
    },
    // 提交表单内容（暂时保存）
    submitFormTemp() {
      this.form.zt = '00'
      this.$confirm('此操作将暂时保存为草稿, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        this.leixing == 'add' || this.leixing == 'copy'
          ? (addNbstMesTemp(this.form).then((e) => {
            this.loading = false
            this.$message.success('保存成功!')
            this.reset()
          }).catch((error) => {
            this.loading = false
          })
          )
          : (
            editNbstMesTemp(this.form).then((e) => {
            this.loading = false
            this.$message.success('保存成功!')
            this.reset()
          }
          ).catch((error) => {
            this.loading = false
          })
          )
      })
    },
    // 提交表单内容（入库）
    submitForm(formName, type) {
      // type:tj zsbc
      // 查看不需要验证
      if (type == 'ck') {
        this.reset()
        return
      }
      // 编辑和复制新增需要验证
      this.$refs[formName].validate((valid, obj) => {
        if (valid) {
          this.form.zt = type == 'zsbc' ? '00' : '01'
          if (type == 'tj') {
            this.$confirm('此操作将不可撤回, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              this.leixing == 'add' || this.leixing == 'copy'
                ? this.addNbstMess(this.form)
                : this.editNbstMess(this.form)
            })
          } else if (type == 'zsbc') {
            this.$confirm('此操作将暂时保存为草稿, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              this.leixing == 'add' || this.leixing == 'copy'
                ? this.addNbstMess(this.form)
                : this.editNbstMess(this.form)
            })
          } else if (type == 'bg') {
            nbsybgqjc(this.form).then((res) => {
              var data = '是否确认变更?'
              if (res.data.data.type == 'success') {
              } else {
                data =
                  "<span style='color:red'>" +
                  res.data.data.msg +
                  '</span>是否确认变更?'
              }
              this.$confirm(data, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning',
                center: true
              }).then((res) => {
                this.loading = true
                nbsybg(this.form).then((res) => {
                  this.loading = false
                  if (res.status == 200) {
                    this.$message.success('保存成功!')
                    this.reset()
                  } else {
                    return
                  }
                }).catch((error) => {
                  this.loading = false
                })
              })
            })
          } else {
            this.reset()
          }
        } else {
          return false
        }
      })
    },
    reset() {
      this.$parent.pupopShow = false
      this.$parent.search()
    },

    // 编辑
    editNbstMess(dataObj) {
      this.loading = true
      editNbstMes(dataObj).then((e) => {
        this.loading = false
        this.$message.success('保存成功!')
        this.reset()
      }).catch((error) => {
        this.loading = false
      })
    },
    // 添加
    addNbstMess(dataObj) {
      this.loading = true
      addNbstMes(dataObj).then((e) => {
        this.loading = false
        this.$message.success('保存成功!')
        this.reset()
      }).catch((error) => {
        this.loading = false
      })
    },
    // 出库单号改变
    ckdhChange(val) {
      this.form.thsldw = ''
      this.options2.forEach((item) => {
        if (item.value == val) {
          this.form.hxpbm = item.ysckxx.hxpbm
          this.form.hxpmc = item.ysckxx.hxpmc
          this.form.syckl = item.ysckxx.syckl
          this.form.syckldw = item.ysckxx.syckldw
          this.form.syjbrmc = item.ysckxx.syjbrmc
          this.form.ckrq = item.ysckxx.ckrq
          this.form.thckbh = item.ysckxx.thckbh
          this.form.thckmc = item.ysckxx.thckmc
        }
      })
    },
    // 仓库改变
    ckmcChange(val) {
      this.options1.forEach((item) => {
        if (item.value == val) this.form.thckmc = item.label
      })
    },

    back() {
      this.reset()
    }
  }
}
</script>
<style scope lang='less'>
.neibu_pup {
  padding-top: 10px;
  .neibu_form {
    width: 90%;
    max-width: 1200px;
    background-color: white;
    margin: auto;
    .neibu_content {
      width: 80%;
      margin: auto;
      padding-top: 40px;
      padding-bottom: 10px;
      .el-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
        }
      }
      .buttonList {
        width: 498px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 40px;
        margin-bottom: 45px;
        display: flex;
        justify-content: center;
        .el-button:nth-child(1) {
          margin-right: 190px;
          background-color: #ebebeb;
          width: 148px;
          height: 60px;
          color: #333333;
          border: none;
        }
        .el-button:nth-child(2) {
          background-color: #4170ff;
          color: white;
          width: 148px;
          height: 60px;
          border: none;
        }
      }
      .XINbuttonList {
        width: 498px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 40px;
        margin-bottom: 45px;
        text-align: center;
        .el-button {
          background-color: #4170ff;
          color: white;
          width: 148px;
          height: 60px;
          border: none;
        }
      }
    }
  }
  .neibu_content_list {
    width: 90%;
    max-width: 1200px;
    background-color: white;
    margin: auto;
    margin-top: 15px;
    .neibu_content {
      width: 80%;
      margin: auto;
      padding-top: 40px;
      padding-bottom: 10px;
      .el-form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
        }
      }
      .buttonList {
        width: 498px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 40px;
        margin-bottom: 45px;
        display: flex;
        justify-content: center;
        .el-button:nth-child(1) {
          margin-right: 190px;
          background-color: #ebebeb;
          width: 148px;
          height: 60px;
          color: #333333;
          border: none;
        }
        .el-button:nth-child(2) {
          background-color: #4170ff;
          color: white;
          width: 148px;
          height: 60px;
          border: none;
        }
      }
      .XINbuttonList {
        width: 498px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 40px;
        margin-bottom: 45px;
        text-align: center;
        .el-button {
          background-color: #4170ff;
          color: white;
          width: 148px;
          height: 60px;
          border: none;
        }
      }
    }
  }
}
</style>
